export default "__VITE_ASSET__B8SrK7Wx__"